import * as Backbone from "backbone";
import * as $ from "jquery";
import * as _ from "lodash";
import { ReportFilesCollection } from "../../../collections/ReportFiles";
import { downloadReport } from "../../reports/ReportUtils";
import { BaseModifyModalView, BaseModifyModalViewOptions } from "../_BaseModifyModal";
import { GenericDeleteModal } from "../GenericDeleteModal";
const moment = require('moment-timezone');

declare var CONFIG;


interface ReportFilesModalOptions extends BaseModifyModalViewOptions {
    report: Backbone.Model;
    parentView: any;
    reportFilesCollection: ReportFilesCollection;
}


export class ReportFilesModalView extends BaseModifyModalView {

    public options: ReportFilesModalOptions;
    private template = _.template(require('../../../templates/modals/reports/reportFiles.html'));

    constructor(options: ReportFilesModalOptions) {
        super(<any> _.extend(options, {
            tagName: 'div',
            events: {
                'shown.bs.modal #reportFilesModal': 'handleModalShown',
                'hidden.bs.modal #reportFilesModal': 'handleModalHidden',
                'click .report-file-download': 'handleDownloadReportFile',
                'click .delete-report-file': 'handleDeleteReportFile'
            }
        }));

        // For base class methods
        this.modalIdSelector = 'reportFilesModal';
    }

    render() {
        var models = _.sortBy(this.options.reportFilesCollection.where({
            report_id: this.options.report.get('id')
        }), 'created').reverse();
        this.$el.html(this.template({
            currentUser: this.options.currentUser,
            moment: moment,
            report: this.options.report,
            reportFilesCollection: new ReportFilesCollection(models, {
                organizationId: this.options.reportFilesCollection.organizationId
            }),
            reporterUrl: CONFIG.reporter.url + '/downloadreportfile'
        }));
        return this;
    }

    private handleDownloadReportFile(e: JQuery.UIEventBase) {
        const reportKey = <string> $(e.currentTarget).attr('id');
        const reportName = this.options.report.get('name');
        downloadReport(reportKey, reportName, this.options.reportFilesCollection.downloadReport());
    }

    handleDeleteReportFile(e) {
        var clickedReportFileId = Number((<any> $(e.currentTarget).attr('data-report-file-id')));
        var clickedReportFile = this.options.reportFilesCollection.findWhere({'id': clickedReportFileId});
        var reportFileDisplayedDate = (<any> $(e.currentTarget).parent().find('.report-file-name').text().trim());

        var modal = new GenericDeleteModal({
            type: 'Report File',
            name: reportFileDisplayedDate,
            func: () => {
                return $.when(clickedReportFile.destroy()).done(() => {
                    // Remove report from list
                    e.target.closest('li').remove();
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    remove() {
        this.$('.modals').empty();
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/reports/ReportFilesModal.ts